import { render } from "./SupplierPrivateCompanyContactPageList.vue?vue&type=template&id=9ee81bc6&ts=true"
import script from "./SupplierPrivateCompanyContactPageList.vue?vue&type=script&lang=ts"
export * from "./SupplierPrivateCompanyContactPageList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__